const COMPANY_ID = 'UsC786';
const BASE_API_URL = 'https://a.klaviyo.com/client';
const LISTS = {
    asia: 'XbQbtr',
    'united-kingdom': 'SyP66S',
    switzerland: 'S4shYa',
    europe: 'RKWgK7',
};

document.addEventListener('DOMContentLoaded', function () {
    const forms = [
        document.getElementById('ContactFooter'),
        document.getElementById('create_customer'),
        document.getElementById('ContactForm'),
        document.getElementById('landing-newsletter'),
        document.getElementById('account-newsletter'),
    ];

    forms.forEach((form) => {
        if (!form) return;

        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            const submitButton = form.querySelector('button');

            submitButton.disabled = true;

            window.Shopify.captcha.protect(form, async () => {
                const language = form.querySelector('input[name="language"]')?.value;
                const country = form.querySelector('input[name="country"]')?.value;
                const source = form.querySelector('input[name="source"]')?.value;
                const hiddenEmail = form.querySelector('input.email[type="hidden"]')?.value;
                const email = form.querySelector('input[type="email"]')?.value || hiddenEmail;
                const market = form.querySelector('input[name="market"]')?.value;
                const marketName = form.querySelector('input[name="market-name"]')?.value;
                const consent = form.querySelector(
                    'input[type="checkbox"][name="customer[accepts_marketing]"]',
                )?.checked;

                let extraParams = [];
                if (form.id === 'ContactForm') {
                    extraParams = [
                        form.querySelector('input#ContactForm-name')?.value,
                        form.querySelector('input#ContactForm-lastname')?.value,
                        form.querySelector('input#ContactForm-phone')?.value,
                    ];
                }

                if (form.id === 'create_customer') {
                    extraParams = [
                        form.querySelector('input#RegisterForm-FirstName')?.value,
                        form.querySelector('input#RegisterForm-LastName')?.value,
                        form.querySelector('input#RegisterForm-phone')?.value,
                        form.querySelector('input#RegisterForm-birth_date')?.value,
                    ];
                }

                if (form.id === 'account-newsletter') {
                    extraParams = [
                        form.querySelector('input#AccountNewsletter-name')?.value,
                        form.querySelector('input#AccountNewsletter-lastname')?.value,
                        form.querySelector('input#AccountNewsletter-phone')?.value,
                        form.querySelector('input#AccountNewsletter-birth_date')?.value,
                    ];
                }

                if (email && (consent || form.id === 'ContactFooter' || form.id === 'landing-newsletter')) {
                    const responseProfile = await createProfile(
                        email,
                        country,
                        source,
                        language,
                        marketName,
                        ...extraParams,
                    );
                    if (responseProfile.ok) {
                        await createSubscription(email, country, market);
                    }
                }

                form.submit();
            });

            return false;
        });
    });
});

function createProfile(
    email,
    country,
    source,
    language,
    market,
    name = null,
    lastname = null,
    phone = null,
    birthday = null,
) {
    const data = {
        data: {
            type: 'profile',
            attributes: {
                email: email,
                first_name: name,
                last_name: lastname,
                properties: {
                    phone_number: phone,
                    'Ecommerce Country': country,
                    'Ecommerce Market': market?.toUpperCase(),
                    'Ecommerce Source': source,
                    'Ecommerce Language': language.toUpperCase(),
                    shopify_birthday: birthday,
                },
            },
        },
    };

    if (phone) sessionStorage.setItem('register_phone_number', phone);
    if (birthday) sessionStorage.setItem('register_birthday', birthday);
    return sendRequest('profiles', data);
}

function updateProfile(email, name = null, lastname = null, phone = null, birthday = null) {
    const data = {
        data: {
            type: 'profile',
            attributes: {
                email: email,
                first_name: name,
                last_name: lastname,
                properties: {
                    phone_number: phone,
                    shopify_birthday: birthday,
                },
            },
        },
    };

    return sendRequest('profiles', data);
}

function createSubscription(email, country, market) {
    const listId = LISTS[market] || LISTS['europe'];

    const data = {
        data: {
            type: 'subscription',
            attributes: {
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: email,
                        },
                    },
                },
            },
            relationships: {
                list: {
                    data: {
                        type: 'list',
                        id: listId,
                    },
                },
            },
        },
    };

    return sendRequest('subscriptions', data);
}

function sendRequest(endpoint, data) {
    const options = {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_API_URL}/${endpoint}?company_id=${COMPANY_ID}`, options).catch((err) => console.error(err));
}
